import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import IdfPresentationOfSignedFormsBlockData from '../../../Models/Content/IdfPresentationOfSignedFormsBlockData';
import IdfPresentationOfSignedFormsMain from './IdfPresentationOfSignedFormsMain';

export default class IdfPresentationOfSignedFormsBlock extends EpiComponent<IdfPresentationOfSignedFormsBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <IdfPresentationOfSignedFormsMain context={this.getContext()} iContent={this.props.data} />;
  }
}
